import styled from 'styled-components';
import DownIcon from '../../assets/ci/footer/down.svg';

export const StyledArrowDownIcon = styled(DownIcon)`
    position: absolute;
    color: rgb(255, 255, 255);
    pointer-events: none;
    right: 14%;
    top: calc(50% - 2.826px);
    transform: translate3d(0px, 0px, 0px);
`;

const ArrowDownIcon = <StyledArrowDownIcon />;

export default ArrowDownIcon;
